const getCustomerType = () => {
  const bodyClassList = document.body.classList;
  if (bodyClassList.contains("customer-type--consumer")) {
    return "consumer";
  } else if (bodyClassList.contains("customer-type--wholesaler")) {
    return "wholesaler";
  } else {
    return "consumer";
  }
};

const productImagesRenderLogic = () => {
  const productImages = document.querySelectorAll(
    ".product .thumbnail-list .thumbnail-list__item",
  );

  const mobileProductImages = document.querySelectorAll(
    ".product .slider--mobile .product__media-item",
  );

  const renderLogic = (consumerType, condition) => {
    productImages.forEach((image) => {
      image.classList.remove("custom-hidden");
    });
    if (consumerType == "consumer" || consumerType == "wholesaler") {
      if (condition == "New") {
        productImages.forEach((image) => {
          if (image.dataset.variantGroupingIds != "") {
            image.classList.add("custom-hidden");
          } else if (image.dataset.variantGroupingIds == "") {
            image.classList.remove("hide-image");
          }
        });
      } 
    } 
    //first leats clear all hidden images in mobileProductImages
    mobileProductImages.forEach((image) =>
      image.classList.remove("custom-hidden"),
    );

    //Basically conllect the data-targets from thumbnails that are not hidden
    let thumbsTargets = Array.from(productImages)
      .filter(
        (productImage) =>
          !productImage.classList.contains("custom-hidden") &&
          !productImage.classList.contains("hide-image"),
      )
      .map((productImage) => productImage.dataset.target);
    mobileProductImages.forEach((image) => {
      !thumbsTargets.includes(image.dataset.mediaId) &&
        image.classList.add("custom-hidden");
    });
  };

  const consumerType = getCustomerType();

  if (consumerType == "normal") {
    return;
  }
  const urlParams = new URLSearchParams(window.location.search);
  const variantId = urlParams.get("variant");
  productImages.forEach((image) => {
    image.classList.remove("custom-hidden");
  });
  if (variantId) {
    const selectedVariantBtn = document.querySelector(
      `.product-variant[data-variant-id="${variantId}"]`,
    );
    if (!selectedVariantBtn) {
      console.error("Couldn't located the variant button");
      return;
    }
    const condition = selectedVariantBtn.dataset.condition;
    renderLogic(consumerType, condition);
  } else {
    productImages.forEach((image) => {
      if (image.dataset.featuredMedia != "true") {
        // image.classList.add("hide-image");
        image.classList.add("custom-hidden");
      }
    });
  }

  const numberOfActiveSlides =
    document
      .querySelector(".product .thumbnail-list")
      ?.querySelectorAll(
        " .thumbnail-list__item.slider__slide:not(.hide-image):not(.custom-hidden)",
      )?.length || 0;

  document.documentElement.style.setProperty(
    "--number_of_items",
    numberOfActiveSlides,
  );
};
document.addEventListener("DOMContentLoaded", function () {
  const addToCartButton = document.querySelector(
    ".product-form__submit.button.button--full-width.button--primary",
  );

  let oldProductToRemove = null;

  let selectedWarrantyVariantId = null;
  let selectedServiceVariantIds = [];
  const cartNotification = document.getElementById("cart-notification");

  document.addEventListener("variant-change", function () {
    setTimeout(() => {
      updateBuyButtonPrice();
    }, 100);
  });

  const warrantyOptionsContainer = document.querySelector("#options");
  const accessoriesOptionsContainer = document.querySelector(
    ".accessories-options",
  );
  const warrantInfoSections = document.querySelectorAll("warranty-btns-info");

  // Hide warranty and accessories options initially
  if (warrantyOptionsContainer) {
    warrantyOptionsContainer.style.display = "none";
  }
  if (accessoriesOptionsContainer) {
    accessoriesOptionsContainer.style.display = "none";
  }
  if (warrantInfoSections) {
    warrantInfoSections.forEach((section) => {
      section.style.display = "none";
    });
  }

  if (addToCartButton) {
    addToCartButton.classList.add("hide-no-var-selected");
  }
  productImagesRenderLogic();

  // Function to handle the warranty button click
  function handleWarrantyButtonClick(event) {
    const button = event.target.closest(".warranty-btn");

    if (button) {
      // Toggle the selected state
      if (button.classList.contains("selected")) {
        button.classList.remove("selected");
        selectedWarrantyVariantId = null;
      } else {
        // Deselect any previously selected button
        document.querySelectorAll(".warranty-btn").forEach((btn) => {
          btn.classList.remove("selected");
        });

        button.classList.add("selected");
        selectedWarrantyVariantId = button.getAttribute("data-variant-id");
        button
          .closest("warranty-option-include")
          .dispatchEvent(new CustomEvent("warranty::change"));
      }

      updateBuyButtonPrice();
      if (
        this.closest("product-info").querySelectorAll(
          ".selected-option:not(.option-selected)",
        ).length === 0
      ) {
        addToCartButton
          .closest("product-info")
          .classList.remove("options-not-selected");
      }
    }
  }

  function updateBuyButtonPrice() {
    const buyButtonPriceElement = document.querySelector("#buy-button-price");
    const baseProductPriceElement = document.querySelector(
      ".price__container[data-discounted-price-cents]",
    );

    if (buyButtonPriceElement && baseProductPriceElement) {
      const basePriceCents = parseInt(
        baseProductPriceElement.dataset.discountedPriceCents || "0",
      );
      let warrantyPriceCents = 0;

      if (selectedWarrantyVariantId) {
        const warrantyButton = document.querySelector(
          `[data-variant-id="${selectedWarrantyVariantId}"]`,
        );
        if (warrantyButton && warrantyButton.dataset.variantPrice) {
          warrantyPriceCents =
            parseFloat(warrantyButton.dataset.variantPrice) * 100;
        }
      }

      const totalPriceCents = basePriceCents + warrantyPriceCents;
      const formattedPrice = new Intl.NumberFormat("en-CA", {
        style: "currency",
        currency: "CAD",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(totalPriceCents / 100);

      buyButtonPriceElement.textContent = formattedPrice;

      document.dispatchEvent(
        new CustomEvent("buy-button-price-updated", {
          detail: { totalPrice: totalPriceCents },
        }),
      );
    }
  }

  // Function to handle service radio toggle
  function handleServiceToggle(event) {
    const radio = event.target;
    const variantId = radio.getAttribute("data-variant-id");
    const serviceOption = radio.closest(".service-option");

    if (radio.checked) {
      if (radio.value === "no") {
        const variantRadio = event.target
          .closest(".service-option__options")
          .querySelector(".toggle-service");
        selectedServiceVariantIds = selectedServiceVariantIds.filter(
          (id) => id !== variantRadio.dataset.variantId,
        );
      } else selectedServiceVariantIds.push(variantId);
      // serviceOption.classList.add("active");
    } else {
      selectedServiceVariantIds = selectedServiceVariantIds.filter(
        (id) => id !== variantId,
      );
      // serviceOption.classList.remove("active");
    }
    radio
      .closest("service-option")
      .dispatchEvent(new CustomEvent("service::change"));
    if (
      this.closest("product-info").querySelectorAll(
        ".selected-option:not(.option-selected)",
      ).length === 0
    ) {
      addToCartButton
        .closest("product-info")
        .classList.remove("options-not-selected");
    }
  }

  // Function to select the default warranty option (2-year warranty)
  function selectDefaultWarranty() {
    const warrantyButtons = document.querySelectorAll(".warranty-btn");
    if (window.location.search.includes("old_key=")) {
      if (warrantyButtons.length > 1) {
        warrantyButtons.forEach((btn) => {
          if (
            window.location.search.includes(btn.dataset.variantId) &&
            !btn.classList.contains("selected")
          ) {
            btn.click();
          }
        });
      }
      return;
    }
    // if (warrantyButtons.length > 1) {
    //   const noWarrantyBTn = warrantyButtons[0];
    //   noWarrantyBTn.classList.add("selected");
    // }
  }

  // Function to show warranty and accessories options
  function showWarrantyAndAccessories() {
    if (warrantyOptionsContainer) {
      warrantyOptionsContainer.style.display = "block";
    }
    if (accessoriesOptionsContainer) {
      accessoriesOptionsContainer.style.display = "block";
    }
    if (warrantInfoSections) {
      warrantInfoSections.forEach((section) => {
        section.style.display = "block";
      });
    }

    if (addToCartButton) {
      addToCartButton.classList.remove("hide-no-var-selected");
    }
    productImagesRenderLogic();
  }

  // Function to check if a variant is selected from the URL
  function checkVariantFromUrl() {
    const urlParams = new URLSearchParams(window.location.search);

    const variantId = urlParams.get("variant");
    if (variantId) {
      showWarrantyAndAccessories();
    } else {
      if (document.querySelector(".product-variant input:checked")) {
        document.querySelector(".product-variant input:checked").checked =
          false;
      }
    }
  }

  // Add event listeners to warranty buttons
  document.querySelectorAll(".warranty-btn").forEach((button) => {
    button.addEventListener("click", handleWarrantyButtonClick);
  });

  // Add event listeners to service toggles
  document.querySelectorAll(".js-option input").forEach((checkbox) => {
    checkbox.addEventListener("change", handleServiceToggle);
  });

  // Add event listener to the variant selector
  const variantSelector = document.querySelector("[name='id']");
  if (variantSelector) {
    variantSelector.addEventListener("change", function () {
      const variantId = this.value;
      const currentUrl = window.location.href.split("?")[0]; // Remove query parameters from URL
      // window.location.href = `${currentUrl}?variant=${variantId}`;
      showWarrantyAndAccessories(); // Show options when a variant is selected
    });
  }

  const updateCartItem = async () => {
    if (!oldProductToRemove) return;
    try {
      const response = await fetch(
        window.Shopify.routes.root + "cart/update.js",
        {
          method: "POST",
          body: oldProductToRemove,
        },
      );

      if (!response.ok) {
        throw new Error("Network response was not ok " + response.statusText);
      }

      const data = await response.json();
    } catch (error) {
      console.error("ERROR: ", error);
    }
  };

  async function addItemsToCart(mainProductVariantIds) {
    const formData = {
      items: [],
    };

    mainProductVariantIds.forEach((mainProductVariantId) => {
      formData.items.push({
        id: parseInt(mainProductVariantId),
        quantity: 1,
        properties: {
          _product_type: PRODUCT_TYPE,
        },
      });
    });

    // Fetching the price of selected warranty and accessories (pseudo-code)
    let warrantyPrice = 0;
    if (selectedWarrantyVariantId) {
      // Fetch the price of the selected warranty variant (replace with actual price fetching logic)
      const warrantyEl = document.querySelector(
        `#warranty-section .warranty-btn[data-variant-id="${selectedWarrantyVariantId}"]`,
      );
      warrantyPrice = parseFloat(warrantyEl.dataset.variantPrice);
      warrantyName = warrantyEl.dataset.name;

      formData.items.forEach((item) => {
        item.properties["_Warranty"] =
          `Warranty Variant ID: ${selectedWarrantyVariantId}`;
        item.properties["_Warranty Price"] = warrantyPrice;
      });
      for (let productId of mainProductVariantIds) {
        formData.items.push({
          id: parseInt(selectedWarrantyVariantId),
          quantity: 1,
          properties: {
            type: "addon",
            _product_type: PRODUCT_TYPE,
            _for_product: productId,
          },
        });
      }
    }

    let accessoriesPrice = 0;
    if (selectedServiceVariantIds.length > 0) {
      // Fetch the prices of the selected accessories variants (replace with actual price fetching logic)
      for (const variantId of selectedServiceVariantIds) {
        const selectedAccessory = document.querySelector(
          `.service-option .toggle-service[data-variant-id="${variantId}"]`,
        );
        const accessoryPrice = parseFloat(
          selectedAccessory.dataset.variantPrice,
        );
        const accessoriesName = selectedAccessory.dataset.name;
        accessoriesPrice += accessoryPrice;
        for (let productId of mainProductVariantIds) {
          formData.items.push({
            id: parseInt(variantId),
            quantity: 1,
            properties: {
              type: "addon",
              _product_type: PRODUCT_TYPE,
              _for_product: productId,
            },
          });
        }
      }
      formData.items.forEach((item) => {
        if (item.properties.type === "addon") {
          return;
        }
        item.properties["_Accessories"] =
          `Accessory Variant IDs: ${selectedServiceVariantIds.join(",")}`;
        item.properties["_Accessories Price"] = accessoriesPrice;

        // Adjust the total price (pseudo-code)
        item.properties["_Total Extra Price"] =
          warrantyPrice + accessoriesPrice;
      });
    }

    const productForm = document.querySelector("product-form");
    productForm.setCustomFormData(formData);
    productForm.submitButton.dataset.hasAddons = "false";
    productForm.submitButton.click();
  }

  async function addItemToCart() {
    const mainProductVariantId = document.querySelector("[name='id']").value;
    const formData = {
      items: [
        {
          id: parseInt(mainProductVariantId),
          quantity: 1,
          properties: {
            _product_type: PRODUCT_TYPE,
          },
        },
      ],
    };

    // Fetching the price of selected warranty and accessories (pseudo-code)
    let warrantyPrice = 0;
    if (selectedWarrantyVariantId) {
      // Fetch the price of the selected warranty variant (replace with actual price fetching logic)
      const warrantyEl = document.querySelector(
        `#warranty-section .warranty-btn[data-variant-id="${selectedWarrantyVariantId}"]`,
      );
      warrantyPrice = parseFloat(warrantyEl.dataset.variantPrice);
      warrantyName = warrantyEl.dataset.name;
      const barcode = warrantyEl.dataset.barcode;

      formData.items[0].properties["_Warranty"] =
        `Warranty Variant ID: ${selectedWarrantyVariantId}`;
      formData.items[0].properties["_Warranty Price"] = warrantyPrice;

      formData.items.push({
        id: parseInt(selectedWarrantyVariantId),
        quantity: 1,
        properties: {
          type: "addon",
          _product_type: PRODUCT_TYPE,
          _for_product: formData.items[0].id,
          __covered_barcode: barcode,
        },
      });
    }

    let accessoriesPrice = 0;
    if (selectedServiceVariantIds.length > 0) {
      // Fetch the prices of the selected accessories variants (replace with actual price fetching logic)
      for (const variantId of selectedServiceVariantIds) {
        const selectedAccessory = document.querySelector(
          `.service-option .toggle-service[data-variant-id="${variantId}"]`,
        );
        const accessoryPrice = parseFloat(
          selectedAccessory.dataset.variantPrice,
        );
        const accessoriesName = selectedAccessory.dataset.name;
        accessoriesPrice += accessoryPrice;
        formData.items.push({
          id: parseInt(variantId),
          quantity: 1,
          properties: {
            type: "addon",
            _product_type: PRODUCT_TYPE,
            _for_product: formData.items[0].id,
          },
        });
        // if (accessoriesName.includes("Professional Installation")) {
        //   formData.items[0].properties["installation"] = accessoriesName;
        // } else if (accessoriesName.includes("Haul-Away & Recycle")) {
        //   formData.items[0].properties["recycle"] = accessoriesName;
        // }
      }
      formData.items[0].properties["_Accessories"] =
        `Accessory Variant IDs: ${selectedServiceVariantIds.join(",")}`;
      formData.items[0].properties["_Accessories Price"] = accessoriesPrice;
    }

    // Adjust the total price (pseudo-code)
    formData.items[0].properties["_Total Extra Price"] =
      warrantyPrice + accessoriesPrice;

    const productForm = document.querySelector("product-form");
    productForm.setCustomFormData(formData);
    productForm.submitButton.dataset.hasAddons = "false";
    productForm.submitButton.click();
  }

  // Add event listener to the "Add to Cart" button if found
  if (addToCartButton) {
    addToCartButton.addEventListener("click", async function (event) {
      // event.preventDefault(); // Prevent the default form submission
      if (
        addToCartButton
          .closest("product-info")
          .querySelectorAll(".selected-option:not(.option-selected)").length > 0
      ) {
        addToCartButton
          .closest("product-info")
          .classList.add("options-not-selected");
        console.error("Customer didn't select options, abort");
        return;
      }
      const selectedOption = addToCartButton
        .closest("product-info")
        .querySelector(
          `.ppf-checked[data-value="New"],.ppf-checked[data-value="Like-New / Refurb."]`,
        );

      if (addToCartButton.dataset.hasAddons === "true") {
        if (oldProductToRemove) await updateCartItem();

        await addItemToCart(); // Call the function to add items to the cart
      }
    });
  } else {
    console.error("Add to Cart button not found");
  }

  const fillDataFromUrl = async () => {
    const url = window.location.search;
    if (url == "") {
      console.info("There are no queries in URL");
      return;
    }
    const cartContents = await fetch(window.Shopify.routes.root + "cart.js")
      .then((response) => response.json())
      .then((data) => {
        return data;
      });

    const itemsIncart = cartContents.items;

    const urlParams = url
      .split("&")
      .filter((param) => !param.includes("?variant="));
    const productAddons = urlParams
      .find((param) => param.includes("product_addons="))
      ?.replace("product_addons=", "")
      .split(",");

    if (!productAddons) return;
    oldProductToRemove = new FormData();

    productAddons.forEach((addon) => {
      if (addon == "") return;
      if (!itemsIncart.find((el) => el.id === parseInt(addon))) {
        oldProductToRemove = null;
        return;
      }
      oldProductToRemove.append(
        `updates[${addon}]`,
        --itemsIncart.find((el) => el.id === parseInt(addon)).quantity,
      );
    });

    const oldKey = urlParams
      .find((el) => el.includes("old_key="))
      .replace("old_key=", "");

    if (oldProductToRemove) {
      oldProductToRemove.append(`updates[${oldKey}]`, 0);
    }

    //fill data
    const buttonsAndInputs = document.querySelectorAll(
      "product-info button.warranty-btn,product-info input.toggle-service",
    );
    buttonsAndInputs.forEach((el) => {
      const elVariantForId = el.dataset.variantId;
      if (productAddons.includes(elVariantForId)) {
        if (el.nodeName == "BUTTON") {
          if (!el.classList.contains("selected")) el.click();
        } else if (el.nodeName == "INPUT") {
          el.checked = true;
          el.dispatchEvent(new Event("change"), { bubbles: "true" });
        }
      }
    });
  };

  // Select the default warranty option on page load
  selectDefaultWarranty();

  // Check if a variant is selected from the URL on page load
  checkVariantFromUrl();

  fillDataFromUrl();
});
